// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { SUPPORTED_ROUTES } from '../constant';
export function isSupportedAuthApiRoutePath(path) {
    return SUPPORTED_ROUTES.includes(path);
}
